import { eventChannel } from "redux-saga";
import { call, cancelled, put, select, take, takeLatest } from "redux-saga/effects";
import type { AnyAction } from "redux";

import type { WatchActiveTasksOnStoriesSubscription } from "../inheritFromWeeb-ui-v2/generated/graphql";
import type { TheirStorySdk } from "../inheritFromWeeb-ui-v2/state/gqlClient";
import { getTheirStorySdkSaga } from "../inheritFromWeeb-ui-v2/state/gqlClient";
import { STORIES_LOADED, STORIES_LOADING, STORIES_CLEAR } from "../../actions/types";
import type { RootState } from "../rootReducer";

import { storyTaskUpdated } from "./actions";

const StoryStateChangeActions = [STORIES_LOADING, STORIES_LOADED, STORIES_CLEAR];

function* onStoryAsyncTaskUpdate(event: WatchActiveTasksOnStoriesSubscription) {
  if ("storyId" in event.watchStoryAsyncTasks) {
    yield put(storyTaskUpdated(event.watchStoryAsyncTasks));
  }
}

function* watchStoriesAsyncTasks(action: AnyAction) {
  if (action.type !== STORIES_LOADED) {
    // If we receive any action other than "loaded" existing subscription will get
    //  cancelled and we don't want to set up anything until new list of stories
    // has been loaded
    return;
  }

  const sdk: TheirStorySdk = yield getTheirStorySdkSaga();
  const state: RootState = yield select();

  const stories: string[] = state.stories.stories.map((s) => s._id);
  if (stories.length) {
    const observable = sdk.watchActiveTasksOnStories({ stories });
    const channel = eventChannel<WatchActiveTasksOnStoriesSubscription>((callback) => {
      const subscription = observable.subscribe(callback);
      return subscription.unsubscribe.bind(subscription);
    });
    try {
      while (true) {
        yield onStoryAsyncTaskUpdate(yield take(channel));
      }
    } finally {
      if (yield cancelled()) {
        channel.close();
      }
    }
  }
}

function* initStoryAsyncTaskWatch() {
  yield takeLatest(StoryStateChangeActions, watchStoriesAsyncTasks);
}

export function* storiesSagas() {
  yield call(initStoryAsyncTaskWatch);
}
